import React from 'react';
import PropTypes from 'prop-types';
import settings from 'front-settings';
import styles from '../cms.module.scss';

export const Image = ({ span, value: { thumbsnails, title = '' } }) => {
  const imgSize = span === 12 ? 480 : 960;
  const { url } = thumbsnails.find(e => e.format === `width-${imgSize}`);
  const { url: url2x } = thumbsnails.find(e => e.format === `width-${imgSize * 2}`);
  const urlPrefix = settings.BASE_URL;

  return (
    <img
      className={styles.cms__image}
      src={`${urlPrefix}${url}`}
      srcSet={`${urlPrefix}${url}, ${urlPrefix}${url2x} 2x`}
      alt={title}
    />
  );
};

Image.propTypes = {
  span: PropTypes.number,
  value: PropTypes.shape({
    thumbsnails: PropTypes.arrayOf(PropTypes.shape({
      format: PropTypes.string,
      height: PropTypes.number,
      url: PropTypes.string,
      width: PropTypes.number,
    })).isRequired,
    title: PropTypes.string,
  }).isRequired,
};

Image.defaultProps = {
  span: 24,
};

export default Image;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/Image/index.js